document.addEventListener('DOMContentLoaded', () => {
    const faqList = document.querySelector('.faq-list');

    if (!faqList) return;

    const faqItems = faqList.querySelectorAll('.item');
    let firstItem = null;
    let firstContent = null;
    let firstIcon = null;
    let firstContentHeight = 0;

    faqItems.forEach((item, index) => {
        const title = item.querySelector('.title');
        const content = item.querySelector('.content');

        if (!title || !content) return;

        // Создаем иконку
        const icon = document.createElement('span');
        icon.className = 'faq-icon';
        icon.textContent = '+';
        icon.style.cssText = 'float: right; font-size: 1.2em; font-weight: bold;';
        title.appendChild(icon);

        // Сохраняем реальную высоту контента
        let contentHeight = 0;
        const calculateHeight = () => {
            // Временно показываем контент для расчета
            const wasHidden = content.style.display === 'none';
            content.style.display = 'block';
            content.style.visibility = 'hidden';
            content.style.position = 'absolute';
            content.style.paddingTop = '14px';
            content.style.paddingBottom = '8px';

            contentHeight = content.scrollHeight;

            // Возвращаем исходное состояние
            content.style.display = wasHidden ? 'none' : '';
            content.style.visibility = '';
            content.style.position = '';
            content.style.paddingTop = '';
            content.style.paddingBottom = '';
        };

        // Рассчитываем высоту при загрузке
        calculateHeight();

        // Сохраняем данные первого элемента для автоматического открытия
        if (index === 0) {
            firstItem = item;
            firstContent = content;
            firstIcon = icon;
            firstContentHeight = contentHeight;
        }

        // Настраиваем начальное состояние (кроме первого элемента)
        if (index !== 0) {
            content.style.maxHeight = '0';
            content.style.opacity = '0';
        }

        title.style.cursor = 'pointer';

        // Обработчик клика
        title.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            // Закрываем все остальные элементы
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    const otherContent = otherItem.querySelector('.content');
                    const otherIcon = otherItem.querySelector('.faq-icon');

                    if (otherContent) {
                        otherItem.classList.remove('active');
                        otherContent.style.maxHeight = '0';
                        otherContent.style.paddingTop = '0';
                        otherContent.style.paddingBottom = '0';
                        otherContent.style.opacity = '0';
                    }
                    if (otherIcon) {
                        otherIcon.textContent = '+';
                    }
                }
            });

            // Переключаем текущий элемент
            if (!isActive) {
                item.classList.add('active');
                // Устанавливаем padding сразу для корректного расчета
                content.style.paddingTop = '14px';
                content.style.paddingBottom = '8px';
                // Используем сохраненную высоту с небольшим запасом
                content.style.maxHeight = (contentHeight + 50) + 'px';
                content.style.opacity = '1';
                icon.textContent = '−';

                // После анимации устанавливаем точную высоту без ограничений
                setTimeout(() => {
                    if (item.classList.contains('active')) {
                        // Пересчитываем реальную высоту
                        const oldMaxHeight = content.style.maxHeight;
                        const oldOverflow = content.style.overflow;
                        content.style.maxHeight = 'none';
                        content.style.overflow = 'visible';
                        const actualHeight = content.scrollHeight;
                        content.style.overflow = 'hidden';
                        content.style.maxHeight = actualHeight + 'px';
                    }
                }, 300);
            } else {
                item.classList.remove('active');
                // Получаем текущую высоту перед закрытием
                const currentHeight = content.scrollHeight;
                content.style.maxHeight = currentHeight + 'px';
                // Принудительно пересчитываем layout
                void content.offsetHeight;
                // Анимируем закрытие
                content.style.maxHeight = '0';
                content.style.paddingTop = '0';
                content.style.paddingBottom = '0';
                content.style.opacity = '0';
                icon.textContent = '+';
            }
        });
    });

    // Открываем первый элемент после инициализации
    if (firstItem && firstContent && firstIcon) {
        firstItem.classList.add('active');
        // Используем точную высоту без анимации для первого элемента
        requestAnimationFrame(() => {
            firstContent.style.maxHeight = 'none';
            firstContent.style.overflow = 'visible';
            firstContent.style.paddingTop = '14px';
            firstContent.style.paddingBottom = '8px';
            const actualHeight = firstContent.scrollHeight;
            firstContent.style.overflow = 'hidden';
            firstContent.style.opacity = '1';
        });
        firstIcon.textContent = '−';
    }
    if(isExist('[data-fancybox-trigger]')){
        let fTriggers = document.querySelectorAll('[data-fancybox-trigger]');
        fTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e)=>{
                e.preventDefault();
                Fancybox.show([{src: `${trigger.href}`, type: "inline"}]);
            })
        });
    }
});